import { gql } from "@apollo/client"

export const ADMIN_INFO = gql`
  query admin {
    user {
      admin {
        user_id
        tags
      }
    }
  }
`

export interface AdminInfo {
  user_id: number
  tags?: string[]
}

export interface AdminInfoResponse {
  user: {
    admin?: AdminInfo
  }
}